import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

const PendingInvoiceListSearchParams = createPaginationSchema()
  .concat(
    createSortSchema(['invoiceId', 'vendorName', 'invoiceDate', 'invoiceTotal', 'purchaseOrder'])
  )
  .concat(
    Yup.object({
      buyerOrgIds: Yup.string().optional(),
    })
  );

export default PendingInvoiceListSearchParams;
